import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconArrowRight: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"arrow-right"} maskId="square-filled-radius-0-stroke-1-IconArrowRight"><path fillRule="evenodd" clipRule="evenodd" d="M14 4.58582L21.4142 12L14 19.4142L12.5858 18L17.5858 13H3V11H17.5858L12.5858 6.00003L14 4.58582Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconArrowRight;
